import { Navigate } from 'react-router-dom';
import { useFlagSearch } from '../FeatureFlagsContext';
import { PhotoboothPage } from '../pages/PhotoboothPage';
import { usePhotoboothEnabled } from '../weddingCountdown';

export function PhotoboothRoute() {
  const flagSearch = useFlagSearch();
  const showPhotobooth = usePhotoboothEnabled();

  if (!showPhotobooth) {
    return <Navigate to={{ pathname: '/', search: flagSearch }} replace />;
  }

  return <PhotoboothPage />;
}
